import React from "react";
import Layout from "./components/Layout"
import './styles/globals.css'
import HeroSection from "./components/HeroSection"
import Cards from "./components/Cards"
import './styles/Cards.css';

function App() {
  return (
    <Layout>
      <HeroSection/>
      <Cards/>
    </Layout>
  );
}

export default App;
